import Box from '@classify/react-core-components/Box';
import Stack from '@classify/react-core-components/Stack';
import Typography from '@classify/react-core-components/Typography';
import Accordion, { Props as AccordionProps } from '@classify/react-core-components/Accordion';
import { styled } from '@classify/react-core-components/styles';

export interface Props extends AccordionProps {
  title?: string;
  image?: string;
  items: Array<{
    question: string;
    answer: string;
    disabled?: boolean;
  }>;
}

const ImageContainer = styled(Box)(({ theme: { breakpoints } }) => ({
  maxWidth: 130,
  [breakpoints.up('sm')]: {
    maxWidth: 160,
  },
  [breakpoints.up('md')]: {
    maxWidth: 200,
  },
  [breakpoints.up('lg')]: {
    maxWidth: 230,
  },
}));

const Image = styled('img')(() => ({
  maxWidth: '100%',
}));

const FAQ = ({ items, expandAriaLabel, image, title, sx }: Props) => (
  <>
    <script type="application/ld+json">
      {JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: items.map((faqItem) => ({
          '@type': 'Question',
          name: faqItem.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: faqItem.answer,
          },
        })),
      })}
    </script>
    <Box sx={sx}>
      <Stack direction={{ xs: 'column', sm: 'row' }} gap={{ xs: 4, md: 8 }}>
        {image && (
          <ImageContainer>
            <Image src={image} alt="" />
          </ImageContainer>
        )}
        <Box sx={{ flex: 1, maxWidth: 768 }}>
          {title && (
            <Typography variant="h3" component="h2" sx={{ marginBottom: 4 }}>
              {title}
            </Typography>
          )}
          <Accordion
            items={items}
            expandAriaLabel={expandAriaLabel}
            slotProps={{ heading: { component: 'h3' } }}
          />
        </Box>
      </Stack>
    </Box>
  </>
);

export default FAQ;
